import React from "react";
import Navbar from "../Navbar/Navbar";
import { useState } from "react";
import { API } from "../../Redux/actions/API";
import { toast } from "react-toastify";

function Add_Coin() {
    const [name,setName]=useState('')
    const [symbol,setSymbol]=useState('')
    const [description,setDesc]=useState('')
    const [rate,setRate]=useState('')
    const [type,setType]=useState('')

    const referral_API = async () => {
      if(name&&symbol&&description&&rate&&type){
        try {
          let responceRight = await API?.post("/AddCoinByAdmin", {
            "coinname": name,
            "coinsymbol": symbol,
            "coindiscription": description,
            "coinrate":rate,
            "cointype":type
          });
    
          console.log("My_Team", responceRight);
          if(responceRight.data.data.result==='SUCCESSFUL'){
          toast.success(responceRight.data.data.result)
          window.location.reload();
          }else{
          toast.error(responceRight.data.data.result)
          }
        } catch (e) {
          console.log("Error While calling Myteam API", e);
        }
      }else{
        toast.error('Please Fill All The Fields')
      }
      };
  

      const handleName=(e)=>{
        const result=e.target.value.replace(/[^a-z]/gi,'')
        setName(result)
      }

      const handleSymbol=(e)=>{
        const result=e.target.value.replace(/[^a-z]/gi,'')
        setSymbol(result)
      }

      
      const handleDesc=(e)=>{
        const result=e.target.value.replace(/[^a-z0-9 ]/gi,'')
        setDesc(result)
      }
      
  return (

    <div>
      <Navbar />
      <div class="content-page">
        <div
          id="content"
          class="content col-lg-12 col-sm-12 ng-scope"
          ng-controller="activateidByZeroPinCtl"
        >
          <div class="panel panel-primary">
            <div class="panel-heading">
              <h4 class="panel-title">Add Coin</h4>
            </div>
            <div
              class="panel-body table-rep-plugin"
              style={{ padding: "8px", overflowY: "scroll" }}
            >
              <div class="row">
                <div class="box col-md-12">
                  <div class="alert alert-block alert-info">
                    <div class="row">
                      <div class="col-md-6 mr-30">
                        <div class="modal-dialog" role="document">
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="popup_net">
                                <h1 className="fw-bold">Add Coin Form</h1>
                                <span
                                  class="metamaskConnection"
                                  style={{ color: "#fff" }}
                                ></span>
                                {/* <!---onclick number increase start--> */}

                                <div className="form-group">
                                  <label>Coin Name</label>
                                  <input
                                    type="text"
                                    id="txtuid"
                                    class="form-control"
                                    name="Coin"
                                    placeholder="Coin Name"
                                    value={name}
                                    onChange={(e)=>handleName(e)}
                                    maxLength="15"
                                  />
                                </div>
                                <div className="form-group">
                                  <label>Coin Symbol</label>
                                  <input
                                    type="text"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter Symbol"
                                    value={symbol}
                                    onChange={(e)=>handleSymbol(e)}
                                    maxLength="10"
                                  />
                                </div>
                                <div className="form-group">
                                  <label>Coin Type</label>
                                  <select name="coin" className="form-control" onChange={(e)=>setType(e.target.value)}>
                                    <option value=''>Select Coin Type</option>
                                    <option value="local">Local Coin</option>
                                    {/* <option value="live">Live Coin</option> */}
                                  </select>
                                </div>

                                <div className="form-group">
                                  <label>Coin Description</label>
                                  <input
                                    type="text"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Coin Description"
                                    name="desc"
                                    value={description}
                                    onChange={(e)=>handleDesc(e)}
                                    maxLength="80"
                                  />
                                </div>
                                <div className="form-group">
                                  <label>Coin Rate</label>
                                  <input
                                    type="number"
                                    inputMode="numeric"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Coin Rate"
                                    maxLength="10"
                                    value={rate}
                                    onChange={(e)=>setRate(e.target.value)}
                                  />
                                </div>

                                <div class="joinbtn d-flex flex-row-reverse me-auto">
                                  <button
                                    id="btnactive"
                                    style={{
                                      color: "white",
                                      border: "solid 1px #ffff",
                                      padding: "10px 20px",
                                      marginTop: "20px",
                                    }}
                                    onClick={()=>referral_API()}
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Add_Coin